import { MoreHorizontal, Pencil } from 'lucide-react';
import { Button } from 'components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { APP_USER_ROLE_OPTIONS } from '../../services/appUsersService';

const roleLabel = (value) =>
  APP_USER_ROLE_OPTIONS.find((o) => o.value === value)?.label?.split('—')[0]?.trim() ||
  value;

const accessSummary = (user) => {
  const parts = [];
  if (user.role === 'admin') parts.push('Full platform');
  else if (user.role === 'poles_lot10') parts.push('Poles LOT 10');
  else if (user.role === 'admin_lot10') parts.push('LOT 10 read-only');
  else if (user.role === 'fuel') parts.push('Fuel report');
  else if (user.role === 'driver') parts.push('Fleet drivers');
  if (user.polesLot10 && user.role === 'driver') parts.push('+ Poles LOT 10');
  if (user.fuelAccess && user.role !== 'fuel') parts.push('+ Fuel');
  if (user.toolsAccess) parts.push('+ Tools');
  if (user.readOnly) parts.push('Read-only');
  if (user.lotScope) parts.push(user.lotScope);
  return parts.join(' · ') || '—';
};

/**
 * @param {{ onEdit?: (user: object) => void }} [options]
 */
export function createAppUserAccessColumns({ onEdit } = {}) {
  return [
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) => (
        <span className="font-medium text-foreground">{row.getValue('name')}</span>
      ),
    },
    {
      accessorKey: 'email',
      header: 'Email',
      cell: ({ row }) => (
        <span className="text-sm text-muted-foreground">{row.getValue('email')}</span>
      ),
    },
    {
      accessorKey: 'role',
      header: 'Role',
      cell: ({ row }) => roleLabel(row.getValue('role')),
    },
    {
      id: 'access',
      header: 'What they see',
      cell: ({ row }) => (
        <span className="text-sm text-muted-foreground">{accessSummary(row.original)}</span>
      ),
    },
    {
      accessorKey: 'active',
      header: 'Status',
      cell: ({ row }) =>
        row.getValue('active') ? (
          <span className="text-emerald-700">Active</span>
        ) : (
          <span className="text-red-600">Disabled</span>
        ),
    },
    {
      id: 'actions',
      enableHiding: false,
      cell: ({ row }) => {
        const user = row.original;
        return (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="h-8 w-8 p-0" aria-label="Open menu">
                <MoreHorizontal className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>Login user</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => onEdit?.(user)}>
                <Pencil className="mr-2 h-4 w-4" />
                Edit PIN & access
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        );
      },
    },
  ];
}
